import FieldWrapper from '../Field-wrapper';
import styles from '../Fields.module.less';
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
const CheckFieldWrapped = props => {
    const {
        id,
        name,
        onChange,
        value,
        kind = 'checkbox',
        inputClassName
    } = props;
    const className = inputClassName === 'input-error' ? `${kind}-error` : kind;
    return (
        <input
            className={styles[className]}
            id={id || name}
            name={name}
            type="checkbox"
            onChange={onChange}
            checked={!!value}
        />
    );
};

export const CheckField = ({
    id,
    inputClassName,
    kind = 'checkbox',
    label,
    labelCase = 'uppercase',
    name,
    onChange,
    onClick,
    required,
    style,
    valid,
    value
}) => {
    const labelclassName =
        labelCase === 'uppercase' ? 'label' : `label-${labelCase}`;
    const className = inputClassName === 'input-error' ? `${kind}-error` : kind;
    return (
        <div
            className={styles['field']}
            id={`field-${id || name}`}
            data-validity={valid ? 'complete' : 'incomplete'}
            style={style}
        >
            <input
                className={styles[className]}
                id={id || name}
                name={name}
                type="checkbox"
                onChange={onChange}
                onClick={onClick}
                checked={!!value}
            />
            {label && (
                <label
                    className={styles[labelclassName]}
                    id={`label-${id || name}`}
                    htmlFor={name}
                >
                    {label}
                    {required && ' *'}
                </label>
            )}
        </div>
    );
};
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
export default FieldWrapper(CheckFieldWrapped, {
    isCheck: true,
    reduxForm: true
});
